import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { logoPlatform } from "../../../../../utils/string";
import Avatar from "@mui/material/Avatar";
import { useTranslationApp } from "../../../../../lib/i18next";
import {
  BOX_SHADOW_THEME,
  CHIP_SEARCH_COMPONENT_COLOR,
  INPUT_COLOR_BORDER,
  LINEAR_GRADIENT_WHITE_CARD,
} from "../../../../../utils/colors";
import { BORDER_RADIUS } from "../../../../../utils/constants";

const PerformingAssetsCard = ({
  title,
  subtitle,
  onSubtitleClick,
  statistics = [],
  previousContent = null,
  nextContent = null,
  platform,
  sx = {},
}) => {
  const { t } = useTranslationApp();
  return (
    <Box
      sx={{
        border: `1px solid ${INPUT_COLOR_BORDER}`,
        boxShadow: BOX_SHADOW_THEME,
        background: LINEAR_GRADIENT_WHITE_CARD,
        borderRadius: `${BORDER_RADIUS * 4}px !important`,
        p: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        ...sx,
      }}
    >
      {platform && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 1,
            gap: 1,
            flexShrink: 0,
          }}
        >
          <Avatar
            data-hide-in-pdf-capture
            src={logoPlatform(platform)}
            variant="square"
            sx={{
              width: 20,
              height: 20,
              ".MuiAvatar-img": { objectFit: "contain" },
            }}
          />
          <Typography variant="h6" fontWeight="600" color="white">
            {t(platform)}
          </Typography>
        </Box>
      )}

      {/* Title Section */}
      {title && (
        <Box sx={{ flexShrink: 0 }}>
          <Typography
            fontSize={"1.2rem"}
            variant="subtitle1"
            fontWeight="600"
            color="white"
            sx={{
              height: 30,
            }}
          >
            {title}
          </Typography>
        </Box>
      )}

      {/* Subtitle Section with optional click */}
      {subtitle && (
        <Typography
          variant="body2"
          onClick={onSubtitleClick}
          sx={{
            ...(onSubtitleClick && {
              color: "#4A90E2",
              textDecoration: "underline",
              cursor: "pointer",
            }),
            mb: 2,
            flexShrink: 0,
          }}
        >
          {subtitle}
        </Typography>
      )}

      {previousContent}

      {/* Statistics Grid */}
      {statistics.length > 0 && (
        <Grid
          container
          spacing={1}
          sx={{
            flex: nextContent ? 0 : 1,
            alignContent: "stretch",
            minHeight: 0,
          }}
        >
          {statistics.map(({ label, value }, index) => (
            <Grid
              item
              xs={6}
              key={index}
              sx={{ display: "flex", minHeight: 0 }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%",
                  bgcolor: CHIP_SEARCH_COMPONENT_COLOR,
                  borderRadius: 2,
                  px: 2,
                  py: 1.5,
                }}
              >
                <Typography
                  variant="caption"
                  fontSize="0.6875rem"
                  color="fields.placeholder"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {label}
                </Typography>
                <Typography
                  variant="body1"
                  fontSize="1.125rem"
                  fontWeight={600}
                  sx={{
                    mt: 0.5,
                    color: "#3c4043",
                    fontVariantNumeric: "tabular-nums",
                  }}
                >
                  {value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Additional Content */}
      {nextContent ? (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            mt: title || subtitle || statistics.length > 0 ? 1 : 0,
          }}
        >
          {nextContent}
        </Box>
      ) : null}
    </Box>
  );
};

export default PerformingAssetsCard;
